import type { Delta } from "../core/delta";
import { useModalFocus } from "../accessibility/useModalFocus";
type Props = {
  delta: Delta;
  stale: boolean;
  onReject: () => void;
  onApply: () => void;
  onResolve: () => void;
};
export function DeltaReviewSheet({
  delta,
  stale,
  onReject,
  onApply,
  onResolve,
}: Props) {
  const dialogRef = useModalFocus<HTMLDivElement>(".secondary-button");
  return (
    <div
      ref={dialogRef}
      class="overlay-sheet tall"
      role="dialog"
      aria-modal="true"
      aria-labelledby="delta-title"
    >
      <span class="sheet-handle" />
      <span class="eyebrow">SAFE APPLY</span>
      <h2 id="delta-title">DELTA REVIEW</h2>
      <div class="context-meta">
        SOURCE CODEX · {delta.chipId.toUpperCase()} · BASE REVISION{" "}
        {delta.baseRevision} · NEXT REVISION {delta.nextRevision}
      </div>
      <p class={`semantic-tag ${stale ? "conflict-status" : "review-status"}`}>
        STATUS — {stale ? "STALE CONFLICT" : delta.status}
      </p>
      <div class="delta-groups">
        <div class="delta-group">
          <strong>ADDITIONS</strong>
          <ul>
            <li>Added root ARCOPEDIA screen.</li>
            <li>Added root MANIFEST screen.</li>
            <li>Added root SYNC screen.</li>
          </ul>
        </div>
        <div class="delta-group">
          <strong>MODIFICATIONS</strong>
          <ul>
            <li>Refined CHIPMAP composition.</li>
            <li>Added transactional DELTA persistence.</li>
            <li>Added modal focus management.</li>
          </ul>
        </div>
        <div class="delta-group">
          <strong>REMOVALS</strong>
          <ul>
            <li>Removed inactive interrupt rows.</li>
            <li>Removed generated interface text.</li>
          </ul>
        </div>
        <div class="delta-group">
          <strong>ROUTE CHANGES</strong>
          <ul>
            <li>BUILD: AVAILABLE -&gt; RECOMMENDED</li>
          </ul>
        </div>
      </div>
      <div class="classification">
        <span>TRUTH — {delta.truth}</span>
        <span>RISK — {delta.risk}</span>
        <span>CONFLICT — {stale ? "ACTIVE" : "CLEAR"}</span>
      </div>
      <p class="meta">
        Applies only if CPU-001 remains at REV {delta.baseRevision}.
      </p>
      <div class="sheet-actions">
        <button class="secondary-button" onClick={onReject}>
          REJECT
        </button>
        {stale ? (
          <button class="secondary-button" onClick={onResolve}>
            RESOLVE CONFLICT
          </button>
        ) : (
          <button class="primary-button" onClick={onApply}>
            APPLY DELTA
          </button>
        )}
      </div>
    </div>
  );
}
